// apps/cli/src/commands/enterprise/campaigns/index.ts
import type { Command } from 'commander';
import { registerEnterpriseCampaignsCreate } from './create';
import { registerEnterpriseCampaignsList } from './list';
import { registerEnterpriseCampaignsPublish, registerEnterpriseCampaignsUnpublish } from './lifecycle';
import { registerEnterpriseCampaignsUpdate } from './update';
import { registerEnterpriseCampaignsView } from './view';

export function registerEnterpriseCampaignsCommand(parent: Command): void {
	const campaigns = parent.command('campaigns').description('Manage your recruitment campaigns');
	registerEnterpriseCampaignsList(campaigns);
	registerEnterpriseCampaignsView(campaigns);
	registerEnterpriseCampaignsCreate(campaigns);
	registerEnterpriseCampaignsUpdate(campaigns);
	registerEnterpriseCampaignsPublish(campaigns);
	registerEnterpriseCampaignsUnpublish(campaigns);
}
